import { useTranslation } from 'react-i18next';

export type TooltipMessages = {
  // Search
  adminSearch: string;
  clearSearch: string;
  resetSearch: string;

  // Common actions
  close: string;
  copyToClipboard: string;
  support: string;

  // Navigation
  companyPageLink: string;
  equipmentPageLink: string;
  equipmentUsagePageLink: string;
  facilityPageLink: string;
  userPageLink: string;
  previousPeriod: string;
  nextPeriod: string;

  // Logs
  logNotifications: string;
  filterLogs: string;
  viewLogDetails: string;
  logStatus: string;

  // Statements
  viewPrintableStatement: string;

  // Clients
  setActiveClientInfo: string;

  // Facilities
  filterFacilities: string;

  // Equipment
  filterEquipment: string;
  equipmentActions: string;
  viewEquipmentDetails: string;
  viewEquipmentId: string;

  // Commissions
  addCommission: string;
  removeCommission: string;
  addSalesCommission: string;
  addReferralCommission: string;

  // Documents
  saveChanges: string;
  cancelEditing: string;
  editComments: string;
  deleteDocument: string;
  processing: string;
  needsReview: string;
  cannotDownloadWhileProcessing: string;
  filterDocuments: string;

  // User actions
  addAnotherCompany: string;

  //Api Data
  columnSettings: string;
};

export const tooltipMessages = (): TooltipMessages => {
  const { t } = useTranslation();

  return {
    // Search
    adminSearch: t('navigation:adminSearch', 'Quickly find Clients, Facilities, Equipment, or Users'),
    clearSearch: t('search:clearSearch', 'Clear the current results'),
    resetSearch: t('search:resetSearch', 'Reset the search box'),

    // Common actions
    close: t('common:close', 'Close'),
    copyToClipboard: 'Copy to clipboard',
    support: t('navigation:support', 'Support'),

    // Navigation
    companyPageLink: t('dashboard:companyPageLink', 'Go to Company page'),
    equipmentPageLink: 'Go to Equipment page',
    equipmentUsagePageLink: 'Go to Equipment Usage page',
    facilityPageLink: 'Go to Facility page',
    userPageLink: 'Go to User page',
    previousPeriod: t('common:previousPeriod', 'Previous Period'),
    nextPeriod: t('common:nextPeriod', 'Next Period'),

    // Logs
    logNotifications: 'Audit recent change logs',
    filterLogs: 'Filter Logs',
    viewLogDetails: 'View Log Details',
    logStatus: 'Only logs generated by external users have a resolution status.',

    // Statements
    viewPrintableStatement: 'View printable version',

    // Clients
    setActiveClientInfo:
      'The active company can be changed at any time by clicking the "Set Active Company" link in the User menu.',

    // Facilities
    filterFacilities: t('facility:filterFacilities', 'Filter Facilities'),

    // Equipment
    filterEquipment: t('equipment:filterEquipment', 'Filter Equipment'),
    equipmentActions: t('equipment:equipmentActions', 'Equipment Actions'),
    viewEquipmentDetails: t('equipment:viewEquipmentDetails', 'View Equipment Details'),
    viewEquipmentId: t('equipment:viewEquipmentId', 'View Equipment ID'),

    // Commission actions
    addCommission: 'Add Commission',
    removeCommission: 'Remove Commission',
    addSalesCommission: 'Add Sales Commission',
    addReferralCommission: 'Add Referral Commission',

    // Documents
    saveChanges: t('clients:documents.saveChanges', 'Save Changes'),
    cancelEditing: t('clients:documents.cancelEditing', 'Cancel Editing'),
    editComments: t('clients:documents.editComments', 'Edit Comments'),
    deleteDocument: t('clients:documents.deleteDocument', 'Delete Document'),
    processing: t('clients:documents.processing', 'Processing'),
    needsReview: t('clients:documents.needsReview', 'Needs Review'),
    cannotDownloadWhileProcessing: t(
      'clients:documents.cannotDownloadWhileProcessing',
      'Cannot Download While Processing'
    ),
    filterDocuments: t('documents:filterDocuments', 'Filter Documents'),

    // User actions
    addAnotherCompany: 'Add another company',

    // Api Data
    columnSettings: t('apiData:columnSettings'),
  };
};
